import React, { PropTypes } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import InputElement from 'react-input-mask';
import Field from '../Field/Field';
import {PHONE_MASK} from '../../../constants/formats';
import './PhoneField.less';

class PhoneField extends Field {
  render () {
    const {label, value, onChange} = this.props;
    const {animateError} = this.state;

    return (
      <AnimateOnChange
          baseClassName="input-field text-field phone-field"
          animationClassName="shake--active"
          animate={animateError}>
        {label && (<label>{label}</label>)}
        <InputElement mask={PHONE_MASK} value={value} onChange={e => {onChange && onChange(e.target.value);}} />
      </AnimateOnChange>
    );
  }
}

PhoneField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default PhoneField;



// WEBPACK FOOTER //
// ./src/components/common/PhoneField/PhoneField.js